import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { CurrentSubscriptionService } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { CalloutComponent } from '@rma/dashboard/generic/ui/callout';
import { NavigationHeaderComponent } from '@rma/dashboard/layout/public/navigation-header';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { addMonths } from 'date-fns';
import { map, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'rma-confirm-pause',
  imports: [
    MatCardModule,
    RmaIconComponent,
    RouterLink,
    TranslocoModule,
    MatButtonModule,
    AsyncPipe,
    DatePipe,
    CalloutComponent,
    NavigationHeaderComponent,
  ],
  templateUrl: './confirm-pause.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmPauseComponent {
  private readonly subscriptionService = inject(CurrentSubscriptionService);

  protected readonly subscriptionEnd$ = this.subscriptionService.currentSubscription$.pipe(map((sub) => sub.subscriptionEnd));
  protected readonly resumesAt$ = this.subscriptionEnd$.pipe(map((subend) => addMonths(new Date(subend ?? ''), 1)));

  public isPaused$ = new Subject<boolean>();

  public handleConfirmPause() {
    this.resumesAt$
      .pipe(switchMap((resumesAt) => this.subscriptionService.pauseSubscription(resumesAt)))
      .subscribe(() => this.isPaused$.next(true));
  }
}
